export let ServiceTemplateType = /*#__PURE__*/function (ServiceTemplateType) {
  ServiceTemplateType["Service"] = "service";
  ServiceTemplateType["Bundle"] = "bundle";
  return ServiceTemplateType;
}({});
export let ServiceTemplateStatus = /*#__PURE__*/function (ServiceTemplateStatus) {
  ServiceTemplateStatus["Active"] = "active";
  ServiceTemplateStatus["Deleted"] = "deleted";
  return ServiceTemplateStatus;
}({});
export let ServiceTemplateUsedIn = /*#__PURE__*/function (ServiceTemplateUsedIn) {
  ServiceTemplateUsedIn["Draft"] = "draft";
  ServiceTemplateUsedIn["ProposalTemplate"] = "proposalTemplate";
  return ServiceTemplateUsedIn;
}({});